import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RosterMorePopoverPageRoutingModule } from './roster-more-popover-routing.module';

import { RosterMorePopoverPage } from './roster-more-popover.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RosterMorePopoverPageRoutingModule
  ],
  declarations: [RosterMorePopoverPage]
})
export class RosterMorePopoverPageModule {}
